import { chain, mean, round, sum, sumBy, times } from 'lodash';
import { PlanType } from '../../../enum';
import { formatNumberByLocale } from '../../../util';
import { LocationTableEntryMode } from '../constants';
export var getYearCount = function (periodLength, chunkSize) { return Math.ceil(periodLength / chunkSize); };
export var computeHighlightBorder = function (_a) {
    var planType = _a.planType, month = _a.month, year = _a.year, yearCount = _a.yearCount, isIncludeAverage = _a.isIncludeAverage;
    return planType === PlanType.Monthly && !isIncludeAverage && !((month + 1) % 12) && year + 1 < yearCount;
};
export var formatValueWithSuffix = function (value, decimal, suffix) {
    if (value == null)
        return '';
    return "".concat(formatNumberByLocale(value, {
        minimumFractionDigits: decimal,
        maximumFractionDigits: decimal,
    })).concat(suffix !== null && suffix !== void 0 ? suffix : '');
};
export var computeChunkSummary = function (values, chunkSize, decimal) {
    return chain(values)
        .chunk(chunkSize)
        .map(function (arr) { return ({
        total: sum(arr),
        avg: round(mean(arr), decimal),
    }); })
        .value();
};
export var convertEntryModeValue = function (oldVal, totalVol, oldMode, newMode, decimal) {
    if (oldVal === null || totalVol <= 0)
        return null;
    if (oldMode === LocationTableEntryMode.Percentage && newMode === LocationTableEntryMode.Absolute) {
        return round((oldVal / 100) * totalVol, decimal);
    }
    if (oldMode === LocationTableEntryMode.Absolute && newMode === LocationTableEntryMode.Percentage) {
        return round((oldVal / totalVol) * 100, decimal);
    }
    return oldVal;
};
export var convertVolumeField = function (_a) {
    var _b, _c;
    var rawVal = _a.rawVal, periodIdx = _a.periodIdx, totalVolumesData = _a.totalVolumesData, oldMode = _a.oldMode, newMode = _a.newMode, decimal = _a.decimal, shouldConvert = _a.shouldConvert, _d = _a.targetField, targetField = _d === void 0 ? 'volume' : _d;
    if (!shouldConvert)
        return null;
    var totalVol = Number((_c = (_b = totalVolumesData === null || totalVolumesData === void 0 ? void 0 : totalVolumesData[periodIdx]) === null || _b === void 0 ? void 0 : _b[targetField]) !== null && _c !== void 0 ? _c : 0);
    var oldVal = Number.isFinite(rawVal) ? Number(rawVal) : null;
    return convertEntryModeValue(oldVal, totalVol, oldMode, newMode, decimal);
};
export var computeTypeSums = function (_a) {
    var locationTypeIndices = _a.locationTypeIndices, periodLength = _a.periodLength, decimal = _a.decimal, queueLocationsData = _a.queueLocationsData, name = _a.name;
    return times(periodLength, function (periodIdx) {
        var vals = locationTypeIndices.map(function (locIdx) {
            var _a, _b, _c;
            var rawVal = (_c = (_b = (_a = queueLocationsData[locIdx]) === null || _a === void 0 ? void 0 : _a.volumes) === null || _b === void 0 ? void 0 : _b[periodIdx]) === null || _c === void 0 ? void 0 : _c[name];
            return rawVal == null ? null : Number(rawVal);
        });
        if (vals.every(function (v) { return v === null; }))
            return null;
        return round(sumBy(vals, function (v) { return v !== null && v !== void 0 ? v : 0; }), decimal !== null && decimal !== void 0 ? decimal : 0);
    });
};
